



import { useState, useEffect,useRef } from "react"
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  IconButton,
  Button,
  InputBase,
  Menu,
  MenuItem,
  CircularProgress,
  Pagination, // Import Pagination
  Typography, // Import Typography for "No data" message
} from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import VisibilityIcon from "@mui/icons-material/Visibility"
import NorthIcon from "@mui/icons-material/North"
import SouthIcon from "@mui/icons-material/South"
import CustomText, { textStyles } from "../../../../components/CustomText"
import arrow from "../../../../assets/arrow.svg"
import tablefilter from "../../../../assets/tablefilter.svg"
import { pdf } from "@react-pdf/renderer"
import CommissionDetails from "./CommissionDetailsDrawer"
import FilterDrawer from "./FilterDrawer" // Ensure this import path is correct
import CommissionPDF from "./CommissionRecordsPDF"
import StatusDropdown from "../../../../components/StatusDropdown"
import { useTranslation } from "react-i18next"
import { BASE_URL } from "../../../../components/BaseUrl"
import { decryptToken } from "../../../../Utlis/Encryption"
import ExportDropdown from "../../../../components/ExportDropdown";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import emptyscreen from "../../../../assets/Dashboard/emptyscreen.svg";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import emptypayment from "../../../../assets/emptypayment.png";
import back from "../../../../assets/back.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { formatNumber } from "../../../../Utlis/formatNumber";
import ExportCommissionRecordExcel from "./comissionExcel"
const CommissionRecord = () => {
  const [selected, setSelected] = useState([])
  const [tableRows, setTableRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState("")
  const [selectedRow, setSelectedRow] = useState(null)
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
  const [loadingExport, setLoadingExport] = useState(false)
  const [sortConfig, setSortConfig] = useState({ key: "date", direction: "desc" })
  const { t } = useTranslation()
  const [tableProcessing, setTableProcessing] = useState(false);
  const [firstLoadDone, setFirstLoadDone] = useState(false);
  const [sortLoading, setSortLoading] = useState(false)
  const [page, setPage] = useState(0)
  const [rowsPerPage] = useState(5)
  const [totalPages, setTotalPages] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
const paginatedRows = tableRows
const [anchorEl, setAnchorEl] = useState(null);
const [menuRowId, setMenuRowId] = useState(null);
const menuAnchorsRef = useRef({});


    const location = useLocation();
const navigate = useNavigate();
const fromDashboard = location.state?.fromDashboard || false;
  const [filters, setFilters] = useState({
    plan_name: [],
    commission_status: [],
    date_from: "",
    date_to: "",
  })
const INITIAL_FILTERS = {
    plan_name: [],
    commission_status: [],
    date_from: "",
    date_to: "",
};
// true if any filter set

const clearFilters = () => {
  setFilters(INITIAL_FILTERS);
  setPage(0); // reset pagination if needed
};
  const rawEncryptedToken = localStorage.getItem("token")
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null
const planNameMap = {
  attendance_yearly: "Attendance Yearly",
  attendance_monthly: "Attendance Monthly",
  full_monthly: "Full Monthly",
  full_yearly: "Full Yearly",
};
  const fetchCommissionData = async (pageNum = page) => {
    // if (tableRows.length === 0) setLoading(true)
      const isInitialLoad = !firstLoadDone;

  if (isInitialLoad) {
    setLoading(true);
  } else {
    setTableProcessing(true);
  }

    const filterParams = new URLSearchParams()
    if (filters.plan_name.length > 0) {
      filterParams.append("plan_name", filters.plan_name.join(","))
    }
    if (filters.commission_status.length > 0) {
      filterParams.append("commission_status", filters.commission_status.join(","))
    }
    if (filters.date_from) filterParams.append("date_from", filters.date_from)
    if (filters.date_to) filterParams.append("date_to", filters.date_to)

    const queryString = filterParams.toString()
    const apiUrl = `${BASE_URL}/payments/account-exec/commissions?page=${pageNum + 1}&limit=${rowsPerPage}&sort_by=${sortConfig.key || "date"}&sort_order=${sortConfig.direction?.toUpperCase() || "DESC"}&search=${searchTerm}${queryString ? `&${queryString}` : ""}`

    try {
      const res = await fetch(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      const result = await res.json()
      const commissions = Array.isArray(result?.data?.data) ? result.data.data : []
      const formattedData = commissions.map((item,index) => ({


        
       id: index + page * rowsPerPage, 
        // id: item.id,
        companyName: item.company_name,
        country: item.country,
        // subscription: item.subscription_plan,
        subscription: planNameMap[item.subscription_plan] || item.subscription_plan,
        paymentAmount: item.amount,
        commission: item.commission_rate,
        status: item.status,
        maxEmployees: item.max_employees || "N/A",
        duration: item.duration_days ? `${item.duration_days} Days` : "N/A",
        expiray: item.trial_end_date
          ? new Date(item.trial_end_date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : "N/A",
        date: new Date(item.created_at).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      }))
      setTableRows(formattedData)
      setTotalPages(result?.data?.pagination?.pages || 0)
      setTotalCount(result?.data?.pagination?.total || 0)
    } catch (err) {
      console.error("Error fetching commission data:", err)
      setTableRows([])
    } finally {
    setLoading(false);
    setTableProcessing(false);
    setFirstLoadDone(true); 
    }
  }

  const isFilterApplied = Object.entries(filters).some(([key, value]) => {
  if (Array.isArray(value)) return value.length > 0;
  return value !== '';
});
  useEffect(() => {
    fetchCommissionData()
  }, [page, sortConfig, searchTerm, filters])

  const handleExportPDF = async () => {
    setLoadingExport(true)
    setTimeout(async () => {
      const blob = await pdf(<CommissionPDF data={tableRows} />).toBlob()
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = `Commission_Records_${new Date().toISOString().slice(0, 10)}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoadingExport(false)
    }, 1000)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1)
  }

  const handleSort = async (key) => {
    let direction = "asc"
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc"
    }
    setSortConfig({ key, direction })
    setSortLoading(true)
  }

  const handleFilterApply = (newFilters) => {
    setFilters(newFilters)
    setPage(0)
  }

  const handleClearAllFilters = (clearedFilters) => {
    setFilters(clearedFilters)
    setPage(0)
  }

  const columns = [
    { key: "companyName", label: t("commissionRecord.columns.companyName") },
    { key: "subscription", label: t("commissionRecord.columns.subscription") },
    { key: "paymentAmount", label: t("commissionRecord.columns.paymentAmount") },
    { key: "commission", label: t("commissionRecord.columns.commission") },
    { key: "status", label: t("commissionRecord.columns.status") },
    { key: "date", label: t("commissionRecord.columns.date") },
    { key: "action", label: t("commissionRecord.columns.action") },
  ]

  const DataStyles = {
    color: "#172B4D",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
      whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
  }

  const HaederStyles = {
    color: "#44546F",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
  }

  if (loading) {
    return (
      <Box sx={{ height: "60vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress size={40} sx={{ color: "#006EC2" }} />
      </Box>
    )
  }
  const statusButtonStyles = {
    Verified: { backgroundColor: "#2196F3", color: "#0D47A1" },
    Active: { backgroundColor: "#F5CD47", color: "#533F04" },
    Inactive: { backgroundColor: "#F87168", color: "#5D1F1A" },
    Blocked: { backgroundColor: "#579DFF", color: "#09326C" },
  }



const fetchAllCommissions = async () => {
  const filterParams = new URLSearchParams();

  if (filters.plan_name.length > 0) {
    filterParams.append("plan_name", filters.plan_name.join(","));
  }
  if (filters.commission_status.length > 0) {
    filterParams.append("commission_status", filters.commission_status.join(","));
  }
  if (filters.date_from) filterParams.append("date_from", filters.date_from);
  if (filters.date_to) filterParams.append("date_to", filters.date_to);

  const queryString = filterParams.toString();

  const apiUrl = `${BASE_URL}/payments/account-exec/commissions?no_pagination=true&sort_by=${sortConfig.key || "date"}&sort_order=${sortConfig.direction?.toUpperCase() || "DESC"}&search=${searchTerm}${queryString ? `&${queryString}` : ""}`;

  const res = await fetch(apiUrl, {
    headers: { Authorization: `Bearer ${token}` },
  });

  const result = await res.json();
  const commissions = Array.isArray(result?.data?.data) ? result.data.data : [];

  return commissions.map((item, index) => ({
    id: index,
    companyName: item.company_name,
    country: item.country,
    subscription: item.subscription_plan,
    paymentAmount: item.amount,
    commission: item.commission_rate,
    status: item.status,
    maxEmployees: item.max_employees || "N/A",
    duration: item.duration_days ? `${item.duration_days} Days` : "N/A",
    expiray: item.trial_end_date
      ? new Date(item.trial_end_date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "N/A",
    date: new Date(item.created_at).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  }));
};

  return (
    <Box sx={{ py: 2, px: 1 }}>

         {fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('clientsTrialDetails.back')} 
      </CustomText>
    </Box>
  </Box>
)}
      <Box sx={{ backgroundColor: "#fff", borderRadius: 2, py: 2, border: "1px solid #E4E6EF" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            px: 2,
            mb: 2,
            rowGap: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CustomText
              sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149", textAlign: "left" }}
            >
              {t("commissionRecord.title")}
            </CustomText>
            {/* Sort loader placed here, next to the title */}
         {tableProcessing && ( <CircularProgress size={16} sx={{ color: "#006EC2" }} />)}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "wrap",
              flexGrow: 1,
              justifyContent: selected.length === 0 ? "center" : "flex-end",
            }}
          >
            {selected.length > 0 ? (
              ["Verified", "Active", "Inactive", "Blocked"].map((label) => (
                <Button
                  key={label}
                  variant="contained"
                  size="small"
                  sx={{
                    px: 2,
                    height: 34,
                    fontSize: 14,
                    fontWeight: 500,
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    backgroundColor: statusButtonStyles[label].backgroundColor,
                    color: statusButtonStyles[label].color,
                    "&:hover": {
                      backgroundColor: statusButtonStyles[label].backgroundColor,
                      opacity: 0.9,
                    },
                  }}
                  onClick={() => {
                    const updated = tableRows.map((row) =>
                      selected.includes(row.id) ? { ...row, status: label } : row,
                    )
                    setTableRows(updated)
                    setSelected([])
                  }}
                >
                  {t(`ClientsRequests.statusLabels.${label}`)}
                </Button>
              ))
            ) : (
              <>
                <Box
                  sx={{
                    mx: "auto",
                    px: 0.5,
                    py: 0.2,
                    borderRadius: 1,
                    height: 34,
                    border: "2px solid #091E4224",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 250,
                  }}
                >
                  <InputBase
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder={t("commissionRecord.searchPlaceholder")}
                    sx={{
                      ml: 0.5,
                      fontSize: 15,
                      letterSpacing: "1px",
                      color: "#939393",
                      fontWeight: 500,
                      width: "100%",
                    }}
                  />
                  <SearchIcon sx={{ fontSize: 22, color: "#888", mr: 0.5 }} />
                </Box>


<ExportDropdown
  onDownloadPDF={async () => {
    const allData = await fetchAllCommissions(); // 👈 fetch all (with filters)
    const blobStream = pdf(<CommissionPDF data={allData}/>).toBlob();
    blobStream.then((blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `Commission_Records_${new Date().toISOString().slice(0, 10)}.pdf`;
      link.click();
    });
  }}
  onDownloadExcel={async () => {
    const allData = await fetchAllCommissions(); // 👈 fetch all (with filters)
    ExportCommissionRecordExcel(allData);
  }}
/>
               

          {isFilterApplied ? (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: "#006EC2", // blue background when filter applied
    }}
  >
    {/* Filter Icon */}
    <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

    {/* Small Cross Badge */}
    <IconButton
      size="small"
      onClick={clearFilters}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
        "&:hover": { bgcolor: "#f5f5f5" },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterDrawerOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
      backgroundColor: "white",
      color: "#5E5C5C",
      "&:hover": { backgroundColor: "#F2F2F2" },
    }}
  >
    <FilterAltIcon sx={{ fontSize: 22 }} />
  </IconButton>
)}

              </>
            )}
          </Box>
        </Box>
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table size="small">
            <TableHead sx={{
                whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
            }}>
              <TableRow>
              
                {columns.map((col) => (
                  <TableCell key={col.key}   sx={{
          ...HaederStyles,
          py: "6px",
          px: "2px",
          textAlign: "center",     // <-- CENTER HEADER TEXT
        }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {col.label}
                      {col.key !== "action" && (
                        <IconButton size="small" onClick={() => handleSort(col.key)}>
                          {sortConfig.key === col.key && sortConfig.direction === "asc" ? (
                            <NorthIcon sx={{ fontSize: "12px" }} />
                          ) : (
                            <SouthIcon sx={{ fontSize: "12px" }} />
                          )}
                        </IconButton>
                      )}
                    </Box>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
         <TableBody>
  {paginatedRows.length === 0 ? (
    <TableRow>
      <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
         <Box sx={{ display: 'flex',flexDirection:"column" ,justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <img src={emptypayment} alt="No Data" style={{ width: 200,  }} />
            <CustomText
    sx={{
      ...textStyles.h1,
      fontWeight: 500,
      fontSize: '16px',
      color: '#003149',
      pt:1,
    }}
  >
  {t('no_commission')}
  </CustomText>

        </Box>
      </TableCell>
    </TableRow>
  ) : (
    paginatedRows.map((row, index) => (
      <TableRow key={row.id} hover>
        <TableCell sx={{ ...DataStyles, textAlign: "center" }}>{row.companyName}</TableCell>
        <TableCell sx={{ ...DataStyles, py: "6px", px: "4px" }}>
          {Array.isArray(row.subscription)
            ? row.subscription.join(", ")
            : String(row.subscription).replace(/[[\]{}"]/g, "")}
        </TableCell>
        <TableCell sx={{ ...DataStyles, textAlign: "center" }}>
          {/* {row.paymentAmount} */}
           {formatNumber(row.paymentAmount, true)}

        </TableCell>
        <TableCell sx={{ ...DataStyles, textAlign: "center" }}>{row.commission}</TableCell>
        <TableCell>
          <Box sx={{ pointerEvents: "none" }}>
            <StatusDropdown currentStatus={row.status} />
          </Box>
        </TableCell>
        <TableCell sx={DataStyles}>{row.date}</TableCell>
        <TableCell sx={DataStyles}>
          <IconButton
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
              setMenuRowId(row.id);
            }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>
    ))
  )}
</TableBody>

          </Table>

          
<Menu
   sx={{fontSize:"15px",boxShadow:"none"}}
  anchorEl={anchorEl}
  open={Boolean(anchorEl)}
  onClose={() => {
    setAnchorEl(null);
    setMenuRowId(null);
  }}
       PaperProps={{
            sx: {
              // minWidth: 80,
              // paddingY: 0.5,
              // boxShadow:"none",
              // border: '1px solid #E0E0E0',
            },
          }}
          MenuListProps={{
            sx: {
              paddingY: 0,
            },
          }}
  anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'center',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'center',
  }}
>
  <MenuItem
    onClick={() => {
        const row = paginatedRows.find((r) => r.id === menuRowId);
      if (row) setSelectedRow(row);
       console.log("Selected row from View:", row);
      setAnchorEl(null);
      setMenuRowId(null);
    }}
    sx={{
      fontSize:"14px",
   fontFamily: 'Poppins, sans-serif',
    }}
  >
    {t("common.view")}
  </MenuItem>
</Menu>
        </TableContainer>


              {/* Message for no data */}
              {paginatedRows.length === 0 && !sortLoading && (
                <TableRow>
                  <TableCell colSpan={columns.length + 1} sx={{ textAlign: "center", py: 2 }}>
                    <Typography variant="body2" color="textSecondary" sx={{ fontFamily: "Poppins, sans-serif" }}>
                      {t("noData")}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}

            <Box sx={{ display: 'flex',flexWrap:"wrap", justifyContent: 'center', mt: 2 }}>
            <Pagination
  count={totalPages}
  page={page + 1}
  onChange={(e, value) => setPage(value - 1)}
  shape="rounded"
  color="primary"
  size="small"
  sx={{
    '& .MuiPaginationItem-root': {
      fontFamily: 'Poppins, sans-serif',
      fontSize: 13,
      fontWeight: 500,
    },
    '& .Mui-selected': {
      backgroundColor: '#E9F3FF',
      color: '#006EC2',
    },
  }}
/>
</Box>
      </Box>

      <CommissionDetails open={!!selectedRow} onClose={() => setSelectedRow(null)} selectedRow={selectedRow} />
      <FilterDrawer
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        initialFilters={filters} // Pass current filters as initial
        onApplyFilters={handleFilterApply} // New prop for applying filters
        onClearAllFilters={handleClearAllFilters} // New prop for clearing filters
      />
    </Box>
  )
}

export default CommissionRecord











